// ════════════════════════════════════════════════════════════════════════
//  Tastenlisten als Text – für die drei Felder, die sie bearbeiten
//
//  „Tasten dieser Lektion“, „Tastaturreihe“ und „Grundstellung“ sind
//  Kommalisten einzelner Zeichen. Die Leertaste steht als ␣, sonst wäre sie
//  im Feld nicht zu sehen.
// ════════════════════════════════════════════════════════════════════════

/**
 * Text zu Tasten – ohne etwas wegzuwerfen.
 *
 * Kein Filter auf „genau ein Zeichen“, und das ist der Kern: die Felder zeigen
 * ihren eigenen Inhalt an. Was hier verschwindet, verschwindet dem Redakteur
 * unter den Fingern.
 *
 * Vorher stand hier `.filter((t) => t.length === 1)`. Beim Tippen ist ein Stück
 * fast immer kurz zu lang oder leer, und so löschte das Feld bei jedem Anschlag
 * die Nachbartaste: aus `f,j,␣` wurde beim Einfügen eines `x` hinter dem `f`
 * die Liste `j,␣`. Ein Komma für einen neuen Eintrag kam gar nicht erst an –
 * damit ließ sich einer Lektion keine Taste hinzufügen.
 *
 * Was jetzt durchkommt, meldet `checkBundle` vor dem Veröffentlichen. Das ist
 * die Aufgabenteilung, die das Projekt ohnehin vorsieht: das Feld nimmt
 * entgegen, die Prüfung entscheidet.
 */
export function parseKeys(value: string): string[] {
  return value.split(",").map((t) => (t === "␣" ? " " : t.trim()));
}

/** Tasten zu Text – die Gegenrichtung, damit das Feld sich selbst wiedergibt. */
export function formatKeys(keys: readonly string[]): string {
  return keys.map((k) => (k === " " ? "␣" : k)).join(",");
}
